import React from "react";
import { withStyles } from "@material-ui/core";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";

const styles = (theme) => ({
  selectDate: {
    width: "175px !important",
    minHeight: "36px",
    fontSize: "12px",
    margin: "10px 0px",
    color: theme.TextColor,
    "& .react-calendar__tile--active": {
      background: theme.HeaderSelectedText,
      color: theme.TextColor,
    },
    "& .react-calendar__tile--now, .react-calendar__tile--now:enabled:hover, .react-calendar__tile--now:enabled:focus":
      {
        background: theme.iconColor,
      },
    "& .react-calendar__tile--hasActive, .react-calendar__tile--hasActive:enabled:hover, .react-calendar__tile--hasActive:enabled:focus":
      {
        background: theme.infoBGColor,
      },
    "& .react-calendar__tile--active:enabled:hover, .react-calendar__tile--active:enabled:focus":
      {
        background: theme.HeaderSelectedText,
      },
    "& .react-daterange-picker__button:enabled:hover .react-daterange-picker__button__icon, .react-daterange-picker__button:enabled:focus .react-daterange-picker__button__icon ":
      {
        stroke: theme.HeaderSelectedText,
      },
    "& .react-daterange-picker__inputGroup__input": {
      color: theme.TextColor
    }
  },
});

const StyledCalendar = (props) => (
  <DateRangePicker
    onChange={props.onChange}
    value={props.selectedDate}
    maxDate={props.maxDate}
    className={props.classes.selectDate}
    clearIcon={props.clearIcon}
    calendarAriaLabel={props.calendarAriaLabel}
  />
);

export default withStyles(styles)(StyledCalendar);
